import { render, staticRenderFns } from "./albumsList.vue?vue&type=template&id=391e995b&scoped=true"
import script from "./albumsList.vue?vue&type=script&lang=js"
export * from "./albumsList.vue?vue&type=script&lang=js"
import style0 from "./albumsList.vue?vue&type=style&index=0&id=391e995b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391e995b",
  null
  
)

export default component.exports